export default class OATPrice {
  constructor({ prices }) {
    let max = -1;
    let min = -1;
    
    let price = prices[0];

    if(prices.length > 1) {
      prices.forEach(p => {
        if(max < p) {
          max = p;
        }

        if(min === -1 || min > p) {
          min = p;
          price = p;
        }
      });
    }

    if(max !== -1 && max !== null) {
      this.max = max;
    }

    if(min !== -1 && min !== null) {
      this.min = min;
    }

    if(price !== null) {
      this.value = price;
    }
  }
}